<template>
  <new-route />
</template>

<script>
import NewRoute from "@/components/3pl/Settings/RoutesAndVehicles/Routes/DoorToDoor/NewRoute/index";
export default {
  components: {
    NewRoute,
  },
};
</script>

<style></style>
